
import { useNavigate } from 'react-router-dom';

interface HeaderPanelProps {
  similarityScore: number;
}

export default function HeaderPanel({ similarityScore }: HeaderPanelProps) {
  const navigate = useNavigate();

  return (
    <div className="w-full bg-gradient-to-r from-purple-500 to-pink-500 py-4 px-6 flex items-center justify-between shadow-lg">
      <div className="flex items-center gap-3">
        <img 
          src="https://public.readdy.ai/ai/img_res/7f96f27d-769f-4f5d-870d-d86825eeadd9.png" 
          alt="Logo" 
          className="w-10 h-10 object-contain"
        />
        <h1 className="text-white font-bold text-lg">Encuesta Likert</h1>
      </div>
      <button
        onClick={() => navigate('/dashboard')}
        className="bg-white/20 backdrop-blur-sm rounded-full px-5 py-2 flex items-center gap-2 hover:bg-white/30 transition-all active:scale-95"
      >
        <i className="ri-user-heart-line text-white text-xl"></i>
        <div className="text-white text-left">
          <p className="text-xs opacity-80">Similitud</p>
          <p className="text-2xl font-bold">{similarityScore}%</p>
        </div>
        <i className="ri-arrow-right-s-line text-white text-xl"></i>
      </button>
    </div>
  );
}
